export default function radioBtnInit() {
  $('[data-radio]').each(function () {
    const radio = $(this).data('radio');
    $(this).find(`input[value='${radio}']`).prop({ checked: true }).trigger(
      'click',
    );
    if ($(this).data('submit')) {
      setTimeout(() => {
        $(this).parents('form').submit();
      }, 10);
    }
  });
}
